import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-rec',
  templateUrl: './dialog-rec.component.html',
  styleUrls: ['./dialog-rec.component.css']
})
export class DialogRecComponent implements OnInit {


  constructor(
    public dialogRef: MatDialogRef<DialogRecComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      this.insurance_plans = data.insurance_plans;
      this.totalCost = Math.round(data.totalCost);
    }
  insurance_plans = [];
  totalCost: number;
  ngOnInit() {
  }

}
